import Popup from '../Popup/Popup';
import Button from '../Button/Button';
import { ButtonType } from '../../types/enums';

import styles from './DeactivatePopup.module.scss';

interface DeactivatePopupProps {
  name: string;
  onDelete: () => void;
  onCancel: () => void;
}

const DeactivatePopup = ({ name, onDelete, onCancel }: DeactivatePopupProps) => {
  return (
    <Popup show onHide={onCancel} title={`Deactivate ${name}?`}>
      <div className={styles.container}>
        <p>This has the following effects:</p>
        <ul>
          <li>The user, {name}, will be not able to log in.</li>
          <li>MonitorMonk will keep checking the user’s websites.</li>
          <li>MonitorMonk will keep displaying and updating the user’s dashobards.</li>
          <li>MonitorMonk will keep charging the user’s credit card.</li>
        </ul>
        <p>This action is reversible. The user can be activated again.</p>
        <div className={styles.actions}>
          <Button type={ButtonType.PRIMARY} fullWidth action={onDelete}>
            Deactivate
          </Button>
          <Button type={ButtonType.GHOST} fullWidth action={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export default DeactivatePopup;
